/* Viewing contents works independently of stock status and theme text renderers. */
class BookishEditionsContents extends HTMLElement {
 connectedCallback(){
  this.controller?.abort();this.controller=new AbortController();
  this.details=this.closest('.product-details');this.dataset.enhanced='';
  const {signal}=this.controller;
  this.addEventListener('click',event=>{
   const tab=event.target.closest('[data-bec-edition]');
   if(tab&&this.contains(tab)){
    this.showEdition(tab.dataset.becEdition);
    const input=this.details?.querySelector('variant-picker input[data-option-value-id="'+tab.dataset.optionValueId+'"]');
    if(input&&!input.checked&&!input.disabled)input.click();
    return;
   }
   const button=event.target.closest('.bec-expand');
   if(button&&this.contains(button)){
    const panel=button.closest('.bec-panel');const expanded=panel.dataset.expanded!=='true';
    panel.dataset.expanded=String(expanded);button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?'Show less −':'View full contents +';
   }
  },{signal});
  this.details?.addEventListener('variant:update',()=>{
   const index=Number(this.dataset.editionPosition)-1;
   const selected=this.details.querySelector('variant-picker input[data-fieldset-index="'+index+'"]:checked');
   if(selected)this.showEdition(selected.value);
  },{signal});
 }
 disconnectedCallback(){this.controller?.abort();}
 showEdition(edition){
  if(![...this.querySelectorAll('[data-bec-panel]')].some(p=>p.dataset.becPanel===edition))return;
  this.querySelectorAll('[data-bec-edition]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.becEdition===edition)));
  this.querySelectorAll('[data-bec-panel]').forEach(p=>p.hidden=p.dataset.becPanel!==edition);
 }
}
if(!customElements.get('bookish-editions-contents'))customElements.define('bookish-editions-contents',BookishEditionsContents);
